module.exports = __webpack_public_path__ + "static/media/image2.5da51c70.png";